import { render, staticRenderFns } from "./FlashNotice.vue?vue&type=template&id=6bf06064&"
import script from "./FlashNotice.vue?vue&type=script&lang=js&"
export * from "./FlashNotice.vue?vue&type=script&lang=js&"
import style0 from "./FlashNotice.vue?vue&type=style&index=0&id=6bf06064&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports